const ElementQueries = require("css-element-queries/src/ElementQueries");
import "core-js/features/array/from";
import "core-js/features/object/assign";
import "intersection-observer";
require('./ie11');

ElementQueries.listen();
